import { useShallow } from "zustand/react/shallow";
import { useBoundStore } from "../state/bound.store";

export const useIsSuperAdmin = () => {
  const { selectedOrg } = useBoundStore(
    useShallow((s) => ({
      selectedOrg: s.selectedOrg,
    })),
  );

  return selectedOrg?.roles?.includes("administrator");
};
